import React, { FC, useState } from 'react';
import { Redirect, useRouteMatch, useLocation } from 'react-router';
import { AuthenticationType } from 'api/public';

import { usePublicClient } from 'hooks';
import storage from 'storage';
import * as paths from 'paths';

import SignIn from './SignIn';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import ForgotPasswordSubmit from './ForgotPasswordSubmit';
import ConfirmSignUp from './ConfirmSignUp';
import Invitation from './Invitation';

import { IAuthContainerProps } from '../types';
import { SESSION_KEY_ES_PATH_AND_QUERY } from '../constants';

const AuthController: FC = () => {
  const [password, setPassword] = useState('');
  const match = useRouteMatch();
  const location = useLocation();

  const client = usePublicClient();
  const { sso_configuration, authentication_type } = client;
  const clientIsSSO = authentication_type === AuthenticationType.Sso && sso_configuration;

  if (clientIsSSO) {
    const { pathname, search } = location;

    const isIndex = match.path === paths.index;
    const isLogin = match.path === paths.login;
    const isSignUp = match.path === paths.signUp;
    const isInvitation = match.path === paths.invitation;

    // TODO: @Tim - Could we simply check for a protected route?
    const savePath = search || ((!isIndex || !search) && !isLogin && !isSignUp && !isInvitation);

    if (savePath) {
      window.sessionStorage.setItem(SESSION_KEY_ES_PATH_AND_QUERY, pathname + search);
    }

    return <Redirect to={paths.sso} />;
  }

  const mainProps: IAuthContainerProps = {
    authData: {
      username: storage.userEmail,
      password,
    },
    updateUsername(newUserName: string) {
      storage.userEmail = newUserName;
    },
    updatePassword(newPassword: string) {
      setPassword(newPassword);
    },
  };

  let Main: FC<IAuthContainerProps> = null;

  switch (match.path) {
    case paths.index:
    case paths.login:
      Main = SignIn;
      break;
    case paths.signUp:
      Main = SignUp;
      break;
    case paths.forgotPassword:
      Main = ForgotPassword;
      break;
    case paths.forgotPasswordSubmit:
      Main = ForgotPasswordSubmit;
      break;
    case paths.confirmSignup:
      Main = ConfirmSignUp;
      break;
    case paths.invitation:
      Main = Invitation;
      break;
    default:
      Main = SignIn;
  }

  return <Main {...mainProps} />;
};

export default AuthController;
